import { IFBFriend } from '../../../../SDK/SDKfb';
import { IRewardItem } from '../../../../State/reducers/score';
import { scaleToFit } from '../../../../Utils/Utils';
import { HighlightEffect } from '../../../Shared/HighlightEffect';
import { PlayerAvatar } from '../../../Shared/PlayerAvatar';
import { RewardGroup } from '../../Win/RewardGroup';

export class HelperFriendPicture extends PIXI.Container {
    private highLight: HighlightEffect;

    constructor(friend: IFBFriend, width: number, height: number, item?: IRewardItem) {
        super();
        const frame = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/button-avatar-frame']);
        frame.scale.set(scaleToFit(frame.width, frame.height, 1.2 * width, 1.2 * height));
        frame.anchor.set(0.5);
        frame.x -= 0.16 * width;
        frame.y += 0.03 * height;
        const playerAvatar = new PlayerAvatar(friend.avatar, width, height);
        this.addChild(playerAvatar, frame);

        if (item) {
            const itemIcon = new RewardGroup(item.id);
            itemIcon.scale.set(
                scaleToFit(itemIcon.width, itemIcon.height, width / 1.2, height / 1.2)
            );
            itemIcon.position.set(frame.x - width / 2, 0);
            const highlight = (this.highLight = new HighlightEffect({ scale: 0.5 }));
            highlight.position = itemIcon.position;
            highlight.appear();
            this.addChildAt(highlight, 0);
            this.addChild(itemIcon);
        }
    }

    public destroy(options?: {
        children?: boolean;
        texture?: boolean;
        baseTexture?: boolean;
    }): void {
        super.destroy(options);
        this.highLight.cleanUp();
    }
}
